import { 
    apiBizGetEmployeeRoleList,
    apiBizGetAuthEmptyList,
    apiBizGetEmployeeRoleInfo,
    apiBizDelEmployeeRole,
    apiBizInsertEmployeeRole,
    apiBizEditEmployeeRole,
    } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_employee_role_list: 'internalAuth/employeeRole/set_employee_role_list',
    set_employee_role_info: 'internalAuth/employeeRole/set_employee_role_info',
    set_employee_role_filter_word: 'internalAuth/employeeRole/set_employee_role_filter_word',
    set_auth_empty_list: 'internalAuth/employeeRole/set_auth_empty_list',
}

// count state 必須是 Object
const state = {
    employeeRoleList: [],
    employeeRoleInfo: [],
    authEmptyList: [],
    filter: {
        word: null,
        options: {

        }
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_EMPLOYEE_ROLE_LIST: (state) => {
        return state.employeeRoleList
    },
    GET_BIZ_EMPLOYEE_ROLE_INFO: (state) => {
        return state.employeeRoleInfo
    },
    GET_BIZ_EMPLOYEE_ROLE_FILTER_WORD: (state) => {
        return state.filter.word
    },
    GET_BIZ_AUTH_EMPTY_LIST: (state) => {
        return state.authEmptyList
    },
    
}

// actions 也是以 Object 形式建構。
const actions = {
    // 取得職務部門列表
    getBizEmployeeRoleList ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiBizGetEmployeeRoleList()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    if( res.data.result.length > 0){
                        commit(types.set_employee_role_list, res.data.result);
                        resolve()
                    }
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 取得單一職務部門
    getBizEmployeeRoleInfo ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiBizGetEmployeeRoleInfo(value)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_employee_role_info, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 取得權限空列表
    getBizAuthEmptyList ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiBizGetAuthEmptyList()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    if( res.data.result.length > 0){
                        commit(types.set_auth_empty_list, res.data.result);
                        resolve()
                    }
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 新增角色
    insertBizEmployeeRole ( {commit,dispatch} , value ) {
        return new Promise((resolve, reject) => {
            apiBizInsertEmployeeRole(value)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 編輯角色
    editBizEmployeeRole ( {commit,dispatch} , value ) {
        return new Promise((resolve, reject) => {
            apiBizEditEmployeeRole(value)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 刪除角色
    delBizEmployeeRole ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiBizDelEmployeeRole(value)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 設定搜尋文字
    setlBizEmployeeRoleFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_employee_role_filter_word, value);
            
        })
    },
}

// mutations
const mutations = {
    [types.set_employee_role_list](state, data){
        state.employeeRoleList = data
    },
    [types.set_employee_role_info](state, data){
        state.employeeRoleInfo = data
    },
    [types.set_auth_empty_list](state, data){
        state.authEmptyList = data
    },
    [types.set_employee_role_filter_word](state, data){
        state.filter.word = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/internalAuth/employeeRole/employeeRole.js